import { useState, lazy, Suspense, useEffect } from "react";

import useToggle from "../../utils/hooks/useToggle";
import useScrollInto from "../../utils/hooks/useScrollInto";
import useScrollSpy from "../../utils/hooks/useScrollSpy";
import styles from "./Header.module.css";

const Header = () => {
  const [modal, setModal] = useState(false);

  const { open, handleOpen, handleClose, handleToggle } = useToggle();
  const [Mobile, setMobile] = useState(false);
  const [activeNav, setActiveNav] = useState(false);
  const [isReadyForInstall, setIsReadyForInstall] = useState(false);
  const scrollTo = useScrollInto();
  useScrollSpy();

  useEffect(() => {
    function handleScroll() {
      setMobile(false);
      window.scrollY > 100 ? setActiveNav(true) : setActiveNav(false);
    }
    window.addEventListener("scroll", handleScroll);

    function handlePWAInit(event) {
      // Prevent the mini-infobar from appearing on mobile.
      /* event.preventDefault(); */
      console.log("👍", "beforeinstallprompt", event);
      // Stash the event so it can be triggered later.
      window.deferredPrompt = event;
      // Remove the 'hidden' class from the install button container.
      setIsReadyForInstall(true);
    }

    window.addEventListener("beforeinstallprompt", handlePWAInit);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("beforeinstallprompt", handlePWAInit);
    };
  }, []);

  const toogleMobileNav = () => {
    setMobile(!Mobile);
  };
  const removeMobileNav = () => {
    setMobile(false);
  };

  const handleLink = (section) => {
    removeMobileNav();
    setMobile(false);
    scrollTo(section);
  };

  async function downloadApp() {
    console.log("👍", "butInstall-clicked");
    const promptEvent = window.deferredPrompt;
    if (!promptEvent) {
      // The deferred prompt isn't available.
      console.log("oops, no prompt event guardado en window");
      return;
    }
    // Show the install prompt.
    promptEvent.prompt();
    // Log the result
    const result = await promptEvent.userChoice;
    console.log("👍", "userChoice", result);
    // Reset the deferred prompt variable, since
    // prompt() can only be called once.
    window.deferredPrompt = null;
    // Hide the install button.
    setIsReadyForInstall(false);
  }

  return (
    <header className={activeNav ? styles.headerActive : styles.header}>
      <nav className={styles.nav}>
        <h3>Portafolio</h3>
        <ul className={styles.navLinks}>
          <li className="home">
            <a title="inicio" href="#!" onClick={() => handleLink("home")}>
              home
            </a>
          </li>
          <li className="portfolio">
            <a
              title="portafolio"
              href="#!"
              onClick={() => handleLink("portfolio")}
            >
              Projects
            </a>
          </li>
          <li className="Recomendaciones">
            <a title="contacto" href="#!" onClick={() => handleLink("clients")}>
              about
            </a>
          </li>
          {/* <li>
              <button
                className={styles.homeBtn}
                type="button"
                onClick={() => setModal(true)}
              >
                APOYAME
              </button>
            </li> */}
        </ul>
        {/*  {Mobile && ( */}
        {true && (
          <ul
            className={`${styles.navMobileLinks} ${
              Mobile ? styles.navMobileLinksWidth : ""
            }`}
          >
            <li className="home">
              <a title="inicio" href="#!" onClick={() => handleLink("home")}>
                Home
              </a>
            </li>
            <li className="portfolio">
              <a
                title="portafolio"
                href="#!"
                onClick={() => handleLink("portfolio")}
              >
                Projects
              </a>
            </li>
            <li className="Recomendaciones">
              <a
                title="contacto"
                href="#!"
                onClick={() => handleLink("clients")}
              >
                About me
              </a>
            </li>
          </ul>
        )}

        <button
          className={Mobile ? styles.closeBtn : styles.openBtn}
          onClick={toogleMobileNav}
          type="button"
          title="Abrir Menu Lateral"
          name="Abrir Menu Lateral"
        >
          <i
            className={
              Mobile ? styles["btn-close-icon"] : styles["btn-open-icon"]
            }
          />
        </button>
      </nav>
    </header>
  );
};

export default Header;
